import { render, staticRenderFns } from "./ModalIncluirDotacaoOrcamentaria.vue?vue&type=template&id=77b27c7c&scoped=true"
import script from "./ModalIncluirDotacaoOrcamentaria.vue?vue&type=script&lang=js"
export * from "./ModalIncluirDotacaoOrcamentaria.vue?vue&type=script&lang=js"
import style0 from "./ModalIncluirDotacaoOrcamentaria.vue?vue&type=style&index=0&id=77b27c7c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b27c7c",
  null
  
)

export default component.exports